import { domainNameProd, domainNameDesv } from './sistemaConfigAppBase';
export const urlsServices = {
  SSO: 'https://sso.ynamulti.com.br/',
  SSOWS: 'https://ssows.ynamulti.com.br/api/',
  BACKENDWS: 'https://quantto.com.br/api/',
};
export let ambiente = '';

if (window.location.hostname.indexOf(domainNameProd) > -1) {
  urlsServices.SSO = 'https://sso.ynamulti.com.br/';
  urlsServices.SSOWS = 'https://ssows.ynamulti.com.br/api/';
  urlsServices.BACKENDWS = 'https://quantto.com.br/api/';
  ambiente = 'PROD';
} else {
  urlsServices.SSO = 'https://ynamultisso.rdca.com.br/';
  urlsServices.SSOWS = 'https://ynamultissows.rdca.com.br/api/';
  urlsServices.BACKENDWS = 'https://quanttoapi.rdca.com.br/api/';
  ambiente = 'HOMO';
  if (window.location.hostname.indexOf(domainNameDesv) > -1) {
    //PARA DESENVOLVIMENTO
    urlsServices.SSO = 'http://localhost:3000/';
    urlsServices.SSOWS = 'http://localhost:8001/api/';
    urlsServices.BACKENDWS = 'http://localhost:80/api/';
    ambiente = 'DESV';
  }
}

